import React, { CSSProperties, MouseEvent } from 'react';

import classNames from 'classnames';

import ComponentType from '../../../types/Component';
import LoadingSpinner from '../LoadingSpinner';

import buttonStyles from './styles.module.scss';

type ButtonType = {
	size?: 'x-small' | 'small' | 'default' | 'large' | 'x-large';
	appearance?: 'primary' | 'primary-stroke' | 'stroke' | 'danger';
	align?: 'fill' | 'center';
	fullWidth?: boolean;
	withShadow?: boolean;
	style?: CSSProperties;
	className?: string;
	disabled?: boolean;
	fakeDisabled?: boolean;
	loading?: boolean;
	onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
	iconLeft?: JSX.Element;
	type?: 'button' | 'submit' | 'reset';
};

const Button: ComponentType<ButtonType> = ({
	size = 'default',
	appearance = 'stroke',
	align = 'center',
	withShadow,
	children,
	style,
	className,
	disabled,
	loading,
	fullWidth,
	onClick,
	iconLeft,
	type,
	fakeDisabled,
}) => {
	const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
		if (disabled || loading) return;
		onClick?.(event);
	};

	return (
		<button
			onClick={handleClick}
			style={style}
			type={type}
			className={classNames([
				className,
				buttonStyles.button,
				size === 'x-small' && buttonStyles.sizeExtraSmall,
				size === 'small' && buttonStyles.sizeSmall,
				size === 'large' && buttonStyles.sizeLarge,
				size === 'x-large' && buttonStyles.sizeExtraLarge,
				appearance === 'primary' && buttonStyles.appearancePrimary,
				appearance === 'primary-stroke' && buttonStyles.appearancePrimaryStroke,
				appearance === 'stroke' && buttonStyles.appearanceStroke,
				appearance === 'danger' && buttonStyles.appearanceDanger,
				withShadow && buttonStyles.withShadow,
				align === 'fill' && buttonStyles.fillContent,
				(disabled || fakeDisabled) && buttonStyles.disabled,
				fakeDisabled && buttonStyles.fakeDisabled,
				loading && buttonStyles.loading,
				fullWidth && buttonStyles.fullWidth,
			])}>
			{iconLeft && <div className={buttonStyles.buttonIconLeft}>{iconLeft}</div>}
			{children}
			{loading && (
				<LoadingSpinner
					isPrimary={false}
					size={size === 'x-small' ? 16 : 24}
					className={buttonStyles.loadingInner}
				/>
			)}
		</button>
	);
};

export default Button;
